import React, { memo, useMemo } from 'react'
import { Grid2, Paper } from '@mui/material'
import { faCoinFront } from '@fortawesome/pro-duotone-svg-icons'

import FaIcon from 'src/components/shared/faIcon/FaIcon'

const CoinGrid = ({ value }) => {
  const gridState = useMemo(() => {
    const newGridState = Array(16).fill(false)
    let count = Math.min(value, 16) // Ensure count doesn't exceed grid size
    const indices = Array.from({ length: 16 }, (_, i) => i)

    // Shuffle indices and assign true to the first `count` indices
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[indices[i], indices[j]] = [indices[j], indices[i]]
    }

    for (let i = 0; i < count; i++) {
      newGridState[indices[i]] = true
    }

    return newGridState
  }, [value])

  return (
    <Grid2 container spacing={1}>
      {gridState.map((isActive, index) => (
        <Grid2 size={{ xs: 3 }} key={index}>
          <Paper
            elevation={3}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              aspectRatio: '1/1',
              minHeight: 50,
              bgcolor: 'background.neutral',
              color: isActive ? 'primary.main' : undefined,
              opacity: isActive ? 1 : 0.5
            }}
          >
            <FaIcon icon={faCoinFront} fontSize={42} bounce={isActive} />
          </Paper>
        </Grid2>
      ))}
    </Grid2>
  )
}

export default memo(CoinGrid)
